export default __webpack_public_path__ + "static/media/no_image_news_announcement.afd77521.svg";